const CL_btn = document.querySelector('.complete_look_btn');
const completeLookSection = document.querySelector('.products-complete-look-section.desktop');
const completeLookSectionMobile = document.querySelector('.products-complete-look-section.mobile');
const thumbSliderMobile = document.querySelector('slider-component.thumbnail-slider.slider-mobile-gutter');

const mblSlideToRemove = () => {
  const target = document.querySelectorAll('.slider--mobile .product__media-item.grid__item.slider__slide')[1];
  const attachListener = document.querySelector(
    '.product__media-list.contains-media.grid.grid--peek.list-unstyled.slider.slider--mobile'
  );

  attachListener.addEventListener('scroll', () => {
    const scrollPosition = target.getBoundingClientRect().left;
    const width = target.getBoundingClientRect().width - 15;

    if (scrollPosition >= width || scrollPosition <= -width) {
      completeLookSectionMobile.classList.remove('show-complete-look');
      CL_btn.style.display = 'block';
      thumbSliderMobile.style.display = 'flex';
    }
  });
};

function handleWindowSize() {
  if (window.innerWidth <= 749) {
    CL_btn.addEventListener('click', () => {
      thumbSliderMobile.style.display = 'none';
      completeLookSectionMobile.classList.add('show-complete-look');
      CL_btn.style.display = 'none';
    });

    const cross_btn_mbl = document.querySelector(
      '.products-complete-look-section.mobile .custom-look-collection .cross-icon'
    );
    cross_btn_mbl.addEventListener('click', () => {
      thumbSliderMobile.style.display = 'flex';
      completeLookSectionMobile.classList.remove('show-complete-look');
      CL_btn.style.display = 'block';
    });

    mblSlideToRemove();
  } else {
    CL_btn.addEventListener('click', () => {
      completeLookSection.classList.add('show-complete-look');
      CL_btn.style.display = 'none';
    });

    const cross_btn = document.querySelector('.custom-look-collection .cross-icon');
    cross_btn.addEventListener('click', () => {
      completeLookSection.classList.remove('show-complete-look');
      CL_btn.style.display = 'block';
    });
  }
}
if (CL_btn) {
  window.addEventListener('load', handleWindowSize);
}

const dragToScroll = () => {
  const element = document.querySelector('.custom-look-collection .image-wrap-pdp');
  let isDown = false,
    startX,
    scrollLeft;

  const notDown = () => {
    isDown = false;
    setTimeout(() => {
      document.querySelector('.custom-look-collection').classList.remove('no-click');
    }, 100);
  };
  const onDown = (e) => {
    isDown = true;
    startX = e.pageX - element.offsetLeft;
    scrollLeft = element.scrollLeft;
  };
  const onMoving = (e) => {
    if (!isDown) return;
    e.preventDefault();

    let x = e.pageX - element.offsetLeft;
    let walk = x - startX;
    element.scrollLeft = scrollLeft - walk;
    document.querySelector('.custom-look-collection').classList.add('no-click');
  };

  if (element) {
    element.addEventListener('mousedown', onDown);
    element.addEventListener('mousemove', onMoving);
    element.addEventListener('mouseleave', notDown);
    element.addEventListener('mouseup', notDown);
  }
};
dragToScroll();
